import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate, useLocation } from "react-router-dom";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import logo from "../../assets/logo_renovations.jpg";
import chat from "../../assets/chat-icon.svg";
import { useTheme } from "@mui/material/styles";

const MyAppBar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [servicesAnchorEl, setServicesAnchorEl] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const location = useLocation();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleServicesMenu = (event) => {
    setServicesAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setServicesAnchorEl(null);
  };

  const handleNavigation = (path) => {
    navigate(path);
    handleClose();
  };

  const handlePageClick = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        scrollToSection(id);
      }, 300);
    } else {
      scrollToSection(id);
    }
    handleClose();
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box>
      <Box
        textAlign={"center"}
        sx={{ backgroundColor: "#4e77fa", color: "white", padding: "5px" }}
      >
        <Typography>CHICAGO AREA HOME REMODELING CONTRACTOR</Typography>
      </Box>
      <AppBar
        position="static"
        sx={{ backgroundColor: "white", color: "black" }}
      >
        <Toolbar sx={{ padding: { xs: "10px", md: "30px" } }}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            justifyContent={"space-between"}
            width={"100%"}
          >
            <Box>
              <img
                src={logo}
                alt="Logo"
                style={{
                  height: "100px",
                  marginRight: "10px",
                  cursor: "pointer",
                }}
                onClick={() => handleNavigation("/")}
              />
            </Box>
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                alignItems: "center",
                marginLeft: "50px",
                gap: 3,
              }}
            >
              <Button color="inherit" onClick={() => handleNavigation("/")}>
                HOME
              </Button>
              <Button
                color="inherit"
                onClick={() => handleNavigation("/testimonials")}
              >
                TESTIMONIALS
              </Button>
              <Button
                color="inherit"
                onClick={() => handlePageClick("ourWork")}
              >
                OUR WORK
              </Button>
              <Button color="inherit" onClick={handleServicesMenu}>
                SERVICES
              </Button>
              <Menu
                anchorEl={servicesAnchorEl}
                open={Boolean(servicesAnchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={() => handlePageClick("services")}>
                  Complete Home Remodeling
                </MenuItem>
                <MenuItem onClick={() => handlePageClick("services")}>
                  Kitchen Remodel
                </MenuItem>
                <MenuItem onClick={() => handlePageClick("services")}>
                  Bathroom Remodel
                </MenuItem>
                <MenuItem onClick={() => handlePageClick("services")}>
                  Tile Installation
                </MenuItem>
                <MenuItem onClick={() => handlePageClick("services")}>
                  Floor Installation
                </MenuItem>
                <MenuItem onClick={() => handlePageClick("services")}>
                  Plumbing
                </MenuItem>
                <MenuItem onClick={() => handlePageClick("services")}>
                  Garage Remodel
                </MenuItem>
                <MenuItem onClick={() => handlePageClick("services")}>
                  Electricity
                </MenuItem>
                <MenuItem onClick={() => handlePageClick("services")}>
                  Handyman Services
                </MenuItem>
              </Menu>
              <Button
                color="inherit"
                onClick={() => handlePageClick("aboutUs")}
              >
                ABOUT US
              </Button>
            </Box>
            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                alignItems: "center",
                marginLeft: "auto",
              }}
            >
              <Box
                display={"flex"}
                sx={{
                  backgroundColor: "black",
                  fontSize: "14px",
                  textTransform: "uppercase",
                  padding: "16px 30px 16px 30px",
                  color: "white",
                  marginRight: "20px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={() => (window.location.href = "tel:+13126361186")}
              >
                <img
                  src={chat}
                  alt="Chat Icon"
                  style={{
                    height: "20px",
                    marginRight: "10px",
                    marginTop: "15px",
                  }}
                />
                <Typography
                  variant="body1"
                  sx={{ marginRight: "20px", fontWeight: 900 }}
                >
                  (312) 636-1186 Alex <br />
                  (773) 661-7901 Nick
                </Typography>
              </Box>

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#4e77fa",
                  fontSize: "14px",
                  textTransform: "uppercase",
                  padding: "16px 30px 16px 30px",
                }}
                onClick={() => handlePageClick("requestForm")}
              >
                REQUEST FREE ESTIMATE
              </Button>
            </Box>

            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ display: { xs: "block", md: "none" } }}
              onClick={handleMenu}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={() => handleNavigation("/")}>HOME</MenuItem>
              <MenuItem onClick={() => handleNavigation("/testimonials")}>
                TESTIMONIALS
              </MenuItem>
              <MenuItem onClick={() => handlePageClick("ourWork")}>
                OUR WORK
              </MenuItem>
              <MenuItem onClick={() => handlePageClick("services")}>
                SERVICES
              </MenuItem>
              <MenuItem onClick={() => handlePageClick("aboutUs")}>
                ABOUT US
              </MenuItem>
              <MenuItem onClick={() => handlePageClick("requestForm")}>
                REQUEST FREE ESTIMATE
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      {isMobile && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Box
            display={"flex"}
            sx={{
              backgroundColor: "black",
              fontSize: "14px",
              textTransform: "uppercase",
              padding: "16px 0px",
              color: "white",
              justifyContent: "center",
              width: "100%",
              cursor: "pointer",
            }}
            onClick={() => (window.location.href = "tel:+13126361186")}
          >
            <img
              src={chat}
              alt="Chat Icon"
              style={{ height: "20px", marginRight: "10px", marginTop: "15px" }}
            />
            <Typography
              variant="body1"
              sx={{ marginRight: "20px", fontWeight: 900 }}
            >
              (312) 636-1186 ALEX <br />
              (773) 661-7901 NICK
            </Typography>
          </Box>
          <Button
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: "#4e77fa",
              fontSize: "14px",
              textTransform: "uppercase",
              padding: "16px 30px 16px 30px",
            }}
            onClick={() => handlePageClick("requestForm")}
          >
            REQUEST FREE ESTIMATE
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default MyAppBar;
